import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-start gap-3" }
const _hoisted_2 = { class: "base-alert-icon shrink-0 mt-0.5" }
const _hoisted_3 = { class: "flex-1 min-w-0" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm font-semibold"
}

import { computed } from 'vue'
import { CheckCircle2, XCircle, AlertTriangle, Info, X } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseAlert',
  props: {
    variant: { default: 'info' },
    title: {},
    visible: { type: Boolean, default: true },
    dismissible: { type: Boolean, default: false },
    wrapperClass: {}
  },
  emits: ["dismiss"],
  setup(__props: any) {

const props = __props



const closeButtonClass = computed(() => {
  const classes: Record<string, string> = {
    info: 'hover:bg-blue-100 dark:hover:bg-blue-900/30 text-blue-500 dark:text-blue-400',
    success: 'hover:bg-green-100 dark:hover:bg-green-900/30 text-green-500 dark:text-green-400',
    warning: 'hover:bg-yellow-100 dark:hover:bg-yellow-900/30 text-yellow-500 dark:text-yellow-400',
    error: 'hover:bg-red-100 dark:hover:bg-red-900/30 text-red-500 dark:text-red-400'
  }
  return classes[props.variant] || classes.info
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition-all duration-300 ease-out",
    "enter-from-class": "opacity-0 -translate-y-2 scale-95",
    "enter-to-class": "opacity-100 translate-y-0 scale-100",
    "leave-active-class": "transition-all duration-200 ease-in",
    "leave-from-class": "opacity-100 translate-y-0 scale-100",
    "leave-to-class": "opacity-0 -translate-y-2 scale-95"
  }, {
    default: _withCtx(() => [
      (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([_ctx.wrapperClass, `base-alert--${_ctx.variant}`]),
            role: "alert"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, [
                (_ctx.variant === 'success')
                  ? (_openBlock(), _createBlock(_unref(CheckCircle2), {
                      key: 0,
                      class: "h-5 w-5"
                    }))
                  : (_ctx.variant === 'error')
                    ? (_openBlock(), _createBlock(_unref(XCircle), {
                        key: 1,
                        class: "h-5 w-5"
                      }))
                    : (_ctx.variant === 'warning')
                      ? (_openBlock(), _createBlock(_unref(AlertTriangle), {
                          key: 2,
                          class: "h-5 w-5"
                        }))
                      : (_openBlock(), _createBlock(_unref(Info), {
                          key: 3,
                          class: "h-5 w-5"
                        }))
              ]),
              _createElementVNode("div", _hoisted_3, [
                (_ctx.title)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.title), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", {
                  class: _normalizeClass(["text-sm", { 'mt-0.5': _ctx.title }])
                }, [
                  _renderSlot(_ctx.$slots, "default")
                ], 2)
              ]),
              (_ctx.dismissible)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["base-alert-close shrink-0 ml-auto -mr-1 -mt-1 p-1 rounded-lg transition-colors duration-150", closeButtonClass.value]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dismiss')))
                  }, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "sr-only" }, "Dismiss", -1)),
                    _createVNode(_unref(X), { class: "h-4 w-4" })
                  ], 2))
                : _createCommentVNode("", true)
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})